import _ from "lodash";
import axios from "axios";

import { useCallback, useEffect, useRef, useState } from "react";
import { endpoints } from "../../utils/endpoints";
import { PostList } from "../PostList/PostList";
import { SearchField } from "./SearchField";
import { config } from "../../constants/config";
import { postsFormatter } from "../../utils/useApiRes";
import { useArchiveContext } from "../../context/archive.context";
import { TO } from "../../utils/TO";

const initSearchState = { search: "", posts: null, page: 1, fetching: true };

export const Search = () => {
	const { categories, prTypes, lang, homeSearchQuery } = useArchiveContext();

	const [searchState, setSearchState] = useState(() => {
		if (!homeSearchQuery) return initSearchState;
		else initSearchState.search = homeSearchQuery;
		return initSearchState;
	});

	const [discoverMore, setDiscoverMore] = useState(true);

	const prevCountRef = useRef();
	useEffect(() => {
		prevCountRef.current = searchState.posts?.length || 0;
	});

	async function _fetchPosts(page, search, isNextPage) {
		setSearchState((s) => ({ ...s, fetching: true }));

		setDiscoverMore(true)

		const endpoint = endpoints.searchField({
			page,
			search,
			lang,
		});

		const [err, result] = await TO(axios.get(endpoint));

		if (err) return console.error("Error: ", err);

		if (isNextPage && prevCountRef.current === result.data.length)
			setDiscoverMore(false);

		console.log(result?.data,  categories, prTypes)

		setSearchState((s) => ({
			...s,
			fetching: false,
			posts: postsFormatter(result?.data || [], categories, prTypes),
		}));
	}

	useEffect(() => _fetchPosts(1, searchState.search), []);

	const handleSearchField = useCallback(
		_.debounce((value) => {
			setSearchState((s) => ({ ...s, search: value }));
			_fetchPosts(1, value);
		}, 300),
		[]
	);

	const fetchNextPage = () => {
		const pageCount = searchState.page === 1 ? 2 : searchState.page + 1;

		_fetchPosts(pageCount, searchState.search, true);

		setSearchState((s) => ({ ...s, page: pageCount }));
	};

	return (
		<>
			<SearchField
				handleSearchField={handleSearchField}
				homeSearchQuery={homeSearchQuery}
			/>
			{searchState.posts && (
				<PostList
					posts={searchState.posts}
					fetchNextPage={fetchNextPage}
					discoverMore={discoverMore}
				/>
			)}
		</>
	);
};
